<template>
    <div class="container">
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />
                <a-divider type="vertical" class="item" />
                <a-range-picker
                    :disabled="loading"
                    :ranges="range_date"
                    class="item"
                    @change="on_date_change"
                    :value="date_range"
                    format="YYYY-MM-DD"
                />
            </div>

            <div class="right-items"></div>
        </div>

        <div class="main">
          <a-row  type="flex" justify="space-around">
            <a-col :span="4">
              <a-table
                  bordered
                  :columns="columns"
                  :dataSource="data_source"
                  rowKey="user_id"
                  :loading="loading"
                  :pagination="false"
                  size="middle"
              >
                <template #title>销售询价排行榜（{{data_source.length }}）</template>

              </a-table>
            </a-col>
            <a-col :span="4">
              <a-table
                  bordered
                  :columns="columns2"
                  :dataSource="data_source2"
                  rowKey="user_id"
                  :loading="loading"
                  :pagination="false"
                  size="middle"
              >
                <template #title>客户询价排行榜（{{data_source2.length }}）</template>
              </a-table>
            </a-col>
            <a-col :span="4">
              <a-table
                  bordered
                  :columns="columns3"
                  :dataSource="data_source3"
                  rowKey="user_id"
                  :loading="loading"
                  :pagination="false"
                  size="middle"
              >
                <template #title>公司询价排行榜（{{data_source3.length }}）</template>
              </a-table>
            </a-col>
            <a-col :span="4">
              <a-table
                  bordered
                  :columns="columns4"
                  :dataSource="data_source4"
                  rowKey="user_id"
                  :loading="loading"
                  :pagination="false"
                  size="middle"
              >
                <template #title>商标询价排行榜（{{data_source4.length }}）</template>
              </a-table>
            </a-col>
            <a-col :span="4">
              <a-table
                  bordered
                  :columns="columns5"
                  :dataSource="data_source5"
                  rowKey="user_id"
                  :loading="loading"
                  :pagination="false"
                  size="middle"
              >
                <template #title>成交商标所属人排行榜（{{data_source5.length }}）</template>

              </a-table>
            </a-col>
          </a-row>

        </div>
    </div>
</template>
<script>
    import moment from "moment";
    import common_pagination from "../../../mixins/common_pagination.js";

    export default {
        mixins: [common_pagination],
        data() {
            return {
                path: "/data/enquiry",
                date_range: [moment().startOf("month"), moment().endOf("month")],
                range_date: {
                    今天: [moment(), moment()],
                    昨天: [moment(new Date()).add(-1, "days"), moment(new Date()).add(-1, "days")],
                    本周: [moment().startOf("week"), moment().endOf("week")],
                    本月: [moment().startOf("month"), moment().endOf("month")],
                },
                columns: [
                    {
                        dataIndex: "user.name",
                        title: "销售",
                        width: 120,
                    },
                    {
                        dataIndex: "total_i",
                        title: "询价次数",
                        width: 120,
                    },
                ],
              columns2: [
                {
                  dataIndex: "member.name",
                  title: "客户姓名",
                  width: 120,
                },
                {
                  dataIndex: "total_i",
                  title: "询价次数",
                  width: 120,
                },
              ],
              columns3: [
                {
                  dataIndex: "name",
                  title: "公司名称",
                  width: 120,
                },
                {
                  dataIndex: "total_i",
                  title: "询价次数",
                  width: 120,
                },
              ],
              columns4: [
                {
                  dataIndex: "trademark.markName",
                  title: "商标名称",
                  width: 120,
                },
                {
                  dataIndex: "total_i",
                  title: "询价次数",
                  width: 120,
                },
              ],
              columns5: [
                {
                  dataIndex: "name",
                  title: "所属人",
                  width: 120,
                },
                {
                  dataIndex: "total_i",
                  title: "成交次数",
                  width: 120,
                },
              ],
                data_source: [],
                data_source2: [],
                data_source3: [],
                data_source4: [],
                data_source5: [],
                loading: false,
            };
        },
        mounted() {
            this.load();
            this.reset_query();
        },
        watch: {
            $route() {
                this.load();
            },
        },
        methods: {
            moment,
            reset_query() {
                const query = this.$route.query;
                if (Object.prototype.hasOwnProperty.call(query, "date_range")) {
                    const arr = query["date_range"].split(",");
                    if (arr.length == 2) {
                        this.date_range = [arr[0] ? moment(arr[0]) : null, arr[1] ? moment(arr[1]) : null];
                    }
                }
            },
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/data/member_distribute?type=four&${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data.sale;
                            this.data_source2 = res.data.member;
                            this.data_source3 = res.data.com_data;
                            this.data_source4 = res.data.trademark;
                            this.data_source5 = res.data.applyName;
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            on_date_change(e) {
                this.date_range = e;
                const value = [e[0].format("YYYY-MM-DD 00:00:00"), e[1].format("YYYY-MM-DD 23:59:59")];
                this.on_field_change(value.join(","), "date_range");
            },
        },
    };
</script>
<style lang="less" scoped>
    .framework-body {
        .main {
            overflow-y: auto;
            position: absolute;
            top: 56px;
            left: 0;
            right: 0;
            bottom: 0;
        }
        .id {
            color: #00000080;
        }
        .h2 {
            margin-top: 32px;
            margin-left: 16px;
        }
    }
</style>
